export default __webpack_public_path__ + "static/media/rw.7472e158.png";